import CommonErrorImage from 'assets/images/commonErrorBG.svg';
import { centerContentHorizontalAndVertical } from 'theme/utility/utility.styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const Maintenance = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ ...centerContentHorizontalAndVertical, height: '100vh' }}>
      <CommonErrorImage />
      <Typography variant="h1">{t('pages.maintenance.title')}</Typography>
      <Typography
        variant="h5"
        sx={{
          mt: 8,
          textAlign: 'center',
          whiteSpace: 'pre-line',
        }}
      >
        {t('pages.maintenance.messageForUser')}
      </Typography>
    </Box>
  );
};
